import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@sunSource/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{ video: boolean; download: boolean; blog: boolean }>;

export const DispatchFilterToggleData: HandlerType = async props => {
    props.dispatch({
        type: "Custom/TabsDataState/filter",
        filterData: {
            video: props.parameter.video,
            download: props.parameter.download,
            blog: props.parameter.blog,
        },
    });
};

export const chain = [DispatchFilterToggleData];

const TabsDataFilterHandler = createHandlerChainRunner(chain, "TabsActiveDataFilter");
export default TabsDataFilterHandler;
